// Elige los popups explicativos segun el idioma resuelto en i18n.js. La
// prosa vive en un archivo por idioma porque lleva marcado y se escribe
// nativa en cada uno, no como traduccion clave a clave.
import { IDIOMA } from '../i18n';
import { EXPLICACIONES as ES } from './explicaciones.es';
import { EXPLICACIONES as EN } from './explicaciones.en';

export const EXPLICACIONES = IDIOMA === 'en' ? EN : ES;
